import $                from 'jquery';
window.$                = $;
window.jQuery           = $;

import 'bootstrap';
import 'bootstrap-css-only';
import 'bootstrap-daterangepicker';
import 'normalize.css';
import 'animate.css';
import '../node_modules/angular-waypoints/dist/angular-waypoints.all'
import "../node_modules/ui-select/dist/select.min.css";
import "../node_modules/bootstrap-daterangepicker/daterangepicker.css";

import CryptoJS         from 'crypto-js';
window.CryptoJS         = CryptoJS;

import * as XLSX        from 'xlsx';
window.XLSX             = XLSX;

import angular          from 'angular';

import moment           from 'moment';


window.moment           = moment;

import 'angular-ui-bootstrap';
import "angular-fixed-table-header";
import ngCookies        from 'angular-cookies';
import uiRouter         from 'angular-ui-router';
import stateHelper      from 'angular-ui-router.statehelper';
import datetimeinput    from 'angular-date-time-input';
import datetimepicker   from 'angularjs-bootstrap-datetimepicker';
import daterangepicker  from 'angular-daterangepicker';
import angularUiSwitch  from 'angular-ui-switch';
import ngNotify         from 'ng-notify';
import ngAfx            from 'angular-animation-fx';
import select           from "ui-select";



/** WEBPACK FOOTER **
 ** ./frontend/vendor.js
 **/